module.exports = __webpack_public_path__ + "static/img/cont1404.ed432ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont1404.jpg
// module id = aUde
// module chunks = 0